module.exports = __webpack_public_path__ + "img/24_18.b76c27fa.png";